import { useEffect } from 'react';

export const useScrollToTop = (dependence: string): void => {
	useEffect(() => {
		if (dependence) {
			window.scrollTo(0, 0);
		}
	}, [dependence]);
};
